import { cartModalSlice } from '../reducers/cart-modal.reducers'

export const { closeCartModal, openCartModal } = cartModalSlice.actions
